// 工具类方法
// ==============================
var twui = {
  // 获取元素在文档中的位置
  offset: function (el) {
    var left = el.offsetLeft
    var top = el.offsetTop
    var parent = el.offsetParent

    while (parent !== null) {
      left += parent.offsetLeft
      top += parent.offsetTop
      parent = parent.offsetParent
    }

    return {
      left: left,
      top: top
    }
  }
}

export default twui



// WEBPACK FOOTER //
// ./src/config/twui.js